module.exports = __webpack_public_path__ + "static/media/vg.47fe9060.svg";